/**
 * @desc 根据最新更新时间推送订单到OMS
 */
const URL = "/rantion-walmart";
import http, { updateResponse } from "@/http";
export function request(
  params: API.walmart.walmartOrder.pushedToSystemOrderByUpdateAt.Params,
  options?: any,
) {
  return updateResponse(
    http(URL + `/walmart/walmartOrder/pushedToSystemOrderByUpdateAt`, {
      method: "GET",
      params,

      ...options,
    }),
  );
}
